<template>
    <MainContentSearchable title="Listado de emails" id="emails" v-model="filters" :meta="loading ? {} : emails.meta" @updated="getEmails">
        <template v-slot:header>
            <h3 class="card-title my-3" v-if="base">Listado de emails de la base: {{ base.nombre }}</h3>
            <div class="my-3">
                <Button @click="showModal('add-base-email')">AÑADIR EMAILS</Button>
                <AddBaseEmails @close="closeModal" :base_id="base_id"/>
            </div>
        </template>

        <template v-slot:content v-if="!loading && emails">
            <div class="table-responsive has-options">
                <table class="table table-hover text-nowrap">
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th class="text-center">Opciones</th>
                        </tr>
                    </thead>
                    <tbody v-if="!loading">
                        <template v-for="(email, index) in emails.data">
                            <tr :key="index">
                                <td>{{ email.email }}</td>
                                <td class="text-center">
                                    <div :class="'btn-group ' + (expand.indexOf(index) >= 0 ? 'show' : '')">
                                        <Button type="button" class="dropdown-toggle" @click.prevent="expandir(index)">OPCIONES</Button>
                                        <div :class="'dropdown-menu ' + (expand.indexOf(index) >= 0 ? 'show' : '')">
                                            <button class="dropdown-item" @click="showModal('editar-base-email-' + email.id)">Editar</button>
                                            <button class="dropdown-item" @click="showModal('borrar-base-email-' + email.id)">Borrar</button>
                                        </div>
                                    </div>
                                </td>
                                <EditarBaseEmail :email="email" @close="closeModal"/>
                                <BorrarBaseEmail :email="email" @close="closeModal"/>
                            </tr>
                        </template>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td colspan="6">
                                <LoaderComponent/>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </template>
    </MainContentSearchable>
</template>

<script>
    import MainContentSearchable from "@/components/backend/components/MainContentSearchable";
    import LoaderComponent from '@/components/preloader/LoaderComponent';
    import AddBaseEmails from './modals/AddBaseEmails';
    import EditarBaseEmail from './modals/EditarBaseEmail';
    import BorrarBaseEmail from './modals/BorrarBaseEmail';

    export default {
        props: ['base_id'],
        data() {
            return {
                emails: null,
                base: null,
                loading: true,
                filters: {
                    per_page: 10,
                    page: 1,
                    search: '',
                    search_for: 'n_abonado',
                    tipo: null
                },
                expand: [],
            }
        },
        created() {
            this.getBase();
            this.getEmails();
        },
        methods: {
            borrar(id) {
                this.loading = true;

                const params = {
                    filters : {},
                    comunicado_id: id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.comunicados.borrar'), params).then(res => {
                    this.expand = [];
                    this.$toast.success(res.data.message);
                    this.getEmail();
                }).finally(() => this.loading = false);
            },
            getBase : function() {
                this.loading = true;

                const params = {
                    filters : {},
                    base_id: this.base_id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.comunicados.bases.get'), params).then(res => {
                    this.base = res.data;
                }).finally(() => this.loading = false);
            },
            getEmails : function() {
                this.loading = true;

                const params = {
                    filters : this.filters,
                    base_id: this.base_id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.comunicados.bases.emails.index'), params).then(res => {
                    this.emails = res.data;
                }).finally(() => this.loading = false);
            },
            expandir(index) {
                if(this.expand.indexOf(index) >= 0) {
                    this.expand.splice(this.expand.indexOf(index), 1);
                } else {
                    this.expand.push(index);
                }
            },
            setPage(page) {
                this.filters.page = page;
                this.getEmails();
            },
            showModal(modal) {
                this.expand = [];
                this.$modal.show(modal);
            },
            closeModal(modal, borrado) {
                this.$modal.hide(modal);
                if(borrado) {
                    this.getEmails();
                }
            },
        },
        components: {
            LoaderComponent, AddBaseEmails, MainContentSearchable, EditarBaseEmail, BorrarBaseEmail
        }
    }
</script>
